import { UnwrapRef } from 'vue'

interface ScrollIntoViewOptions {
  behavior?: 'auto' | 'instant' | 'smooth'
  block?: 'start' | 'center' | 'end' | 'nearest'
  inline?: 'start' | 'center' | 'end' | 'nearest'
}

const useScrollIntoView = (element: UnwrapRef<null>|Element, options: ScrollIntoViewOptions = {}) => {
  const reduceMotion = window.matchMedia('prefers-reduced-motion').matches

  return () => element?.scrollIntoView({
    behavior: reduceMotion ? 'instant' : 'smooth',
    block: 'start',
    inline: 'nearest',
    ...options
  });
}
export default useScrollIntoView
